import { render, staticRenderFns } from "./ProcessTab.vue?vue&type=template&id=873c150e&scoped=true&"
import script from "./ProcessTab.vue?vue&type=script&lang=js&"
export * from "./ProcessTab.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTab.vue?vue&type=style&index=0&id=873c150e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873c150e",
  null
  
)

export default component.exports